<script>
import CustomContainerQuery from './CustomContainerQuery.vue'
import * as Vue from 'vue'

export default {
  name: 'ContainerQueryWrapper',
  components: {
    CustomContainerQuery
  },
  props: {
    query: {
      type: Object,
      required: true
    },
    onChange: {
      type: Function,
      default: () => {}
    },
    outerLayout: {
      type: Object,
      required: true
    },
    i18nRender: {
      type: [Function, Boolean],
      default: false
    },
    contentWidth: {
      type: String,
      default: 'Fluid'
    },
    breadcrumbRender: {
      type: Function,
      default: null
    }
  },
  setup(props) {
    // 使用 provide 传递配置
    Vue.provide('locale', props.i18nRender)
    Vue.provide('contentWidth', props.contentWidth)
    Vue.provide('breadcrumbRender', props.breadcrumbRender)
    
    const handleChange = (params) => {
      if (props.onChange) {
        props.onChange(params)
      }
    }
    
    return {
      handleChange
    }
  },
  render() {
    // 调试：检查 outerLayout
    console.log('ContainerQueryWrapper: outerLayout', this.outerLayout)
    console.log('ContainerQueryWrapper: outerLayout type', typeof this.outerLayout)
    console.log('ContainerQueryWrapper: outerLayout keys', this.outerLayout ? Object.keys(this.outerLayout) : 'null')
    
    // 使用 render 函数直接渲染 VNode
    // 关键：在 Vue 3 中，需要确保 VNode 正确传递
    // 如果 outerLayout 是 VNode，直接使用；否则需要转换
    let layoutToRender = this.outerLayout
    
    // 检查是否是有效的 VNode
    if (!layoutToRender || (typeof layoutToRender !== 'object')) {
      console.error('ContainerQueryWrapper: outerLayout is not a valid VNode', layoutToRender)
      return Vue.h('div', { style: { color: 'red' } }, 'Error: outerLayout is not valid')
    }
    
    // 返回 CustomContainerQuery，包含 layoutToRender
    return Vue.h(CustomContainerQuery, {
      query: this.query,
      onChange: this.handleChange
    }, {
      default: () => layoutToRender
    })
  }
}
</script>
